import type { Decorator, FormApi } from 'final-form';
import { useRef } from 'react';

/**
 * Позволяет добавлять в submitForm дополнительные вызовы
 */
export const decorateSubmit =
    (
        decorator: (form: FormApi<Record<string, unknown>>) => void
    ): Decorator<Record<string, unknown>> =>
    form => {
        const next = form.submit;

        // eslint-disable-next-line no-param-reassign
        form.submit = () => {
            decorator(form);

            return next();
        };

        return () => {
            // eslint-disable-next-line no-param-reassign
            form.submit = next;
        };
    };

/** Мемоизатор декораторов, которые должны принимать аргументы при маунте */
export const useDecorator = <T>(func: T) => useRef(func).current;
